import React from 'react'
import { useIntl } from 'react-intl'
import { Card } from 'app-v2/design-systems/components/containers/card'
import { H6 } from 'app-v2/design-systems/typography/titles'
import { Spacer } from 'app-v2/design-systems/components/Spacer/Spacer'
import { SIZE } from 'app-v2/design-tokens'
import { BodyText } from 'app-v2/design-systems/typography/text'
import { StyledCardContainer } from 'app-v2/modules/king-table/features/welcome-screen/components/table-card/styles'

// type TableCardProps = {
//     restaurantPath: string,
//     table: string
// }

export const NoDesktopCard = () => {
    const intl = useIntl()
    return (
        <StyledCardContainer>
            <Card center>
                <H6>
                    {intl.formatMessage({
                        id: 'ecommerce.kingtable.no-desktop.title'
                    })}
                </H6>
                <Spacer size={SIZE.XS} />
                <BodyText center>
                    {intl.formatMessage({
                        id: 'ecommerce.kingtable.no-desktop.description'
                    })}
                </BodyText>
                <Spacer size={SIZE.L} />
            </Card>
        </StyledCardContainer>
    )
}
